<e-dialog [open]="target() !== null" (openChange)="onOpenChange($event)" [title]="text().title">
  <ng-template>
    <div class="print-dialog">
      <div class="print-dialog__field">
        <span class="print-dialog__label">{{ text().colorScheme }}</span>
        <ng-select
          class="print-dialog__select"
          data-test-id="print-dialog-color-scheme"
          [items]="colorSchemeOptions()"
          bindLabel="label"
          bindValue="id"
          [clearable]="false"
          [searchable]="false"
          [ngModel]="colorScheme()"
          (ngModelChange)="colorScheme.set($event)"
        ></ng-select>
      </div>

      <div class="print-dialog__field">
        <span class="print-dialog__label">{{ text().name }}</span>
        <e-segmented-toggle
          testId="print-dialog-name-mode"
          [groupLabel]="text().name"
          [options]="nameModeOptions()"
          [value]="nameMode()"
          (valueChange)="onNameModeChange($event)"
        />
        <input
          class="form-control form-control-sm print-dialog__name"
          type="text"
          data-test-id="print-dialog-name"
          [placeholder]="text().namePlaceholder"
          [value]="name()"
          (input)="onNameInput($event)"
          (keydown.enter)="submit()"
        />
      </div>

      <div class="print-dialog__field">
        <span class="print-dialog__label">{{ text().layout }}</span>
        <e-segmented-toggle
          testId="print-dialog-layout"
          [groupLabel]="text().layout"
          [options]="layoutOptions()"
          [value]="layout()"
          (valueChange)="layout.set($event)"
        />
      </div>

      <!-- Keynotes enkel bij Basis: naast de LPS-grids van Regulier en in het wiel van Mandala is er geen plaats. -->
      @if (layout() === 'basic') {
        <div class="switch primary-switch print-dialog__switch">
          <label class="mb-0">
            <span>{{ text().centerKeynotes }}</span>
            <input
              type="checkbox"
              data-test-id="print-dialog-center-keynotes"
              [checked]="centerKeynotes()"
              (change)="onCenterKeynotesChange($event)"
            />
            <span class="lever"></span>
          </label>
        </div>
      }

      <div class="print-dialog__actions">
        <button eBtn color="primary-75" icon="file-pdf" data-test-id="print-dialog-create" [disabled]="!canCreate" (click)="submit()">
          {{ text().create }}
        </button>
      </div>
    </div>
  </ng-template>
</e-dialog>
